import { useEffect, useRef } from "react";
import Pusher from "pusher-js";
import { isUsdt0Code } from "const";
import { getDepositTokenCode, getUserAccount } from "types";
export function getPaymentStatusChannel(info) {
    var _a;
    if (!info)
        return null;
    if (info.kind === "withdrawal" || isUsdt0Code(getDepositTokenCode(info))) {
        return ((_a = info.rozo) === null || _a === void 0 ? void 0 : _a.payment_id) ? "payments-".concat(info.rozo.payment_id) : null;
    }
    var account = getUserAccount(info);
    return account ? "deposit-".concat(account) : null;
}
var PUSHER_KEY = "22273733a3d287ae4279";
var PUSHER_CLUSTER = "us2";
var EVENT_NAME = "status-update";
export function usePaymentStatusPusher(opts) {
    var callbacks = useRef(opts);
    callbacks.current = opts;
    useEffect(function () {
        var _a;
        if (!opts.channelName)
            return;
        var pusher = new Pusher(PUSHER_KEY, { cluster: PUSHER_CLUSTER });
        var channelName = opts.channelName;
        var logPrefix = (_a = opts.logPrefix) !== null && _a !== void 0 ? _a : "[payment:pusher]";
        var channel = pusher.subscribe(channelName);
        console.debug("".concat(logPrefix, " subscribed"), {
            channelName: channelName,
            eventName: EVENT_NAME,
        });
        channel.bind(EVENT_NAME, function (payload) {
            var _a, _b, _c, _d, _e, _f;
            console.debug("".concat(logPrefix, " event"), {
                channelName: channelName,
                eventName: EVENT_NAME,
                status: payload.status,
                deposit_id: payload.deposit_id,
            });
            (_b = (_a = callbacks.current).onAny) === null || _b === void 0 ? void 0 : _b.call(_a, payload);
            if (payload.status === "payment_payin_completed") {
                (_d = (_c = callbacks.current).onDetected) === null || _d === void 0 ? void 0 : _d.call(_c, payload);
            }
            if (payload.status === "payment_payout_completed") {
                (_f = (_e = callbacks.current).onCompleted) === null || _f === void 0 ? void 0 : _f.call(_e, payload);
                console.debug("".concat(logPrefix, " completed; disconnecting"), {
                    channelName: channelName,
                    deposit_id: payload.deposit_id,
                });
                pusher.disconnect();
            }
        });
        return function () {
            console.debug("".concat(logPrefix, " cleanup"), { channelName: channelName });
            channel.unbind_all();
            pusher.unsubscribe(channelName);
            pusher.disconnect();
        };
    }, [opts.channelName, opts.logPrefix]);
}
export function useDepositStatusPusher(opts) {
    usePaymentStatusPusher({
        channelName: opts.walletAddress ? "deposit-".concat(opts.walletAddress) : null,
        onAny: opts.onAny,
        onDetected: opts.onDetected,
        onCompleted: opts.onCompleted,
        logPrefix: "[deposit:pusher]",
    });
}
